/* eslint-disable react-native/no-inline-styles */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, View } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import TodoProductItem from '@/screens/sales-activity/components/todo-list/on-going/product/TodoProductItem';
import { KeyboardAwareFlatList } from 'react-native-keyboard-aware-scroll-view';
import Colors from '@global/colors';
import { productKeyExtractor } from './TodoVisibilityUpdate.utils';

const VisibilityResultOtherProductList = ({
  products = [],
  hasDefaultProducts = false,
  filterProducts = (val) => val,
  detailData = {},
  detailTodo = {},
  handleProductUpdate = () => {},
  customerAddress = {},
  navigation = {},
  showProduct = false,
  accountGroupId = null,
  isValueSellOutOnly = false,
}) => {
  const listNode = useMemo(() => {
    const filtered = filterProducts(products);

    if (!hasDefaultProducts && !filtered?.length) {
      return null;
    }

    if (filtered.length === 0) {
      return (
        <View
          testID="todo-visibility-other-product-list-empty"
          style={styles.productEmpty}>
          <SociollaText style={styles.productEmptyText}>
            Other product not found.
          </SociollaText>
        </View>
      );
    }

    return (
      <KeyboardAwareFlatList
        testID="todo-visibility-other-product-list"
        style={{ flex: 1 }}
        data={filtered}
        showsVerticalScrollIndicator={true}
        windowSize={8}
        maxToRenderPerBatch={8}
        initialNumToRender={8}
        updateCellsBatchingPeriod={40}
        removeClippedSubviews={true}
        enableOnAndroid={true}
        extraScrollHeight={80}
        keyExtractor={productKeyExtractor}
        renderItem={({ item }) => (
          <TodoProductItem
            item={item}
            isDetail
            selectedProduct={products}
            activityId={detailData?._id}
            todoId={detailTodo?._id}
            onChange={(val) => handleProductUpdate(val, true)}
            customerAddress={customerAddress}
            taskIdStorage={detailTodo?._id || ''}
            isOtherProduct={true}
            navigation={navigation}
            showProduct={showProduct}
            accountGroupId={accountGroupId}
            isValueSellOutOnly={isValueSellOutOnly}
          />
        )}
      />
    );
  }, [
    products,
    hasDefaultProducts,
    filterProducts,
    detailData?._id,
    detailTodo?._id,
    handleProductUpdate,
    customerAddress,
    navigation,
    showProduct,
    accountGroupId,
    isValueSellOutOnly,
  ]);

  return listNode;
};

const styles = StyleSheet.create({
  productEmpty: {
    width: '100%',
    padding: 15,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  productEmptyText: {
    fontSize: 13,
    color: Colors.grey2,
  },
});

VisibilityResultOtherProductList.propTypes = {
  products: PropTypes.array,
  hasDefaultProducts: PropTypes.bool,
  filterProducts: PropTypes.func,
  detailData: PropTypes.object,
  detailTodo: PropTypes.object,
  handleProductUpdate: PropTypes.func,
  customerAddress: PropTypes.object,
  navigation: PropTypes.object,
  showProduct: PropTypes.bool,
};

export default React.memo(VisibilityResultOtherProductList);
